// extracted by mini-css-extract-plugin
module.exports = {"page":"PageContainer_page__2myrk"};